import React from 'react';
import { Box, Popover, TextContent } from '@amzn/awsui-components-core';
import { UserProfile, Owner } from '@amzn/awscat-pattern-library-service-model';

import constants from '../../common/constants';

interface Props {
  owners: Owner[];
  userProfile: UserProfile;
}

const CollectionOwners = ({ owners, userProfile }: Props) => {
  // place current user to first position
  const reorderedOwners = owners.find((owner) => owner.userId === userProfile.userId)
    ? [userProfile, ...owners.filter((owner) => owner.userId !== userProfile.userId)]
    : owners;
  if (reorderedOwners.length <= 2) {
    return <span>{reorderedOwners.map((owner) => owner.name).join(', ')}</span>;
  } else {
    return (
      <span>
        {/* @ts-expect-error TS2532 - strict migration */}
        {`${reorderedOwners[0].name} and `}
        <Popover
          position="right"
          dismissAriaLabel="Close additional authors"
          content={
            <div>
              <Box>{`${constants.MY_COLLECTION_ADDITIONAL_AUTHORS} (${owners.length})`} </Box>
              <TextContent>
                {owners.map((owner) => (
                  <li key={owner.name}>{owner.name}</li>
                ))}
              </TextContent>
            </div>
          }
        >
          {reorderedOwners.length - 1} more
        </Popover>
      </span>
    );
  }
};

export default CollectionOwners;
